import { VaccineEnum } from "requests";

export const VACCINE_NAME_TO_TITLE = {
  [VaccineEnum.CanineInfluenza]: "Canine Influenza",
  [VaccineEnum.Bordatella]: "Bordetella",
  [VaccineEnum.Leptospirosis]: "Leptospirosis",
  [VaccineEnum.Da2pp]: "DA2PP",
  [VaccineEnum.Rabies]: "Rabies",
  [VaccineEnum.Fvrcp]: "FVRCP",
  [VaccineEnum.FelineLeukemia]: "Feline Leukemia"
};
